// extracted by mini-css-extract-plugin
module.exports = {"gridHeader":"shop-module--gridHeader--WTS3A","gridContainer":"shop-module--gridContainer--2ektS"};